import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { AdOrderContext } from '../../contexts/AdOrder'
import Label from './Label'
import InputWrap from './InputWrap'
import useInput from '../../hooks/useInput'

export default function Input ({
  name,
  label,
  labelExtraText,
  placeholder,
  autocomplete,
  required = false,
  type = 'text',
  size,
  subobj = null,
  pattern
}) {
  const { getValue, setValue } = useInput()

  const handleOnChange = function (e) {
    setValue(name, e.target.value, subobj)
  }

  return (
    <InputWrap size={size}>
      <Label htmlFor={name} required={required} extraText={labelExtraText}>{label}</Label>
      <input
        value={getValue(name, subobj) ?? ''}
        type={type}
        placeholder={placeholder}
        required={required}
        autoComplete={autocomplete}
        onChange={handleOnChange}
        pattern={pattern}
      />
    </InputWrap>
  )
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  autocomplete: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.oneOf(['half', 'third']),
}